import { getCookie, cookiesConstants, buildGtmBannerEventData } from '@magalu/mixer-utils';
var buildServerEventData = function buildServerEventData(banner, index) {
  return [{
    adType: 'SPONSORED_BANNER',
    position: index !== null && index !== void 0 ? index : 0,
    trackId: banner.trackId
  }];
};
var getCustomerId = function getCustomerId(staticCustomerId) {
  var CUSTOMER_ID = cookiesConstants.CUSTOMER_ID;
  return staticCustomerId || getCookie(CUSTOMER_ID);
};
var buildVideoProgressionEventData = function buildVideoProgressionEventData() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$duration = _ref.duration,
    duration = _ref$duration === void 0 ? 0 : _ref$duration,
    _ref$currentTime = _ref.currentTime,
    currentTime = _ref$currentTime === void 0 ? 0 : _ref$currentTime,
    _ref$progressPercent = _ref.progressPercent,
    progressPercent = _ref$progressPercent === void 0 ? 0 : _ref$progressPercent;
  return {
    video_current_time: currentTime,
    video_duration: duration,
    video_percent: progressPercent
  };
};
var trackClick = function trackClick(_ref2) {
  var banner = _ref2.banner,
    eventDetails = _ref2.eventDetails,
    isBannerCarousel = _ref2.isBannerCarousel,
    isVideo = _ref2.isVideo,
    screenName = _ref2.screenName,
    structure = _ref2.structure,
    trackingFunctions = _ref2.trackingFunctions;
  if (!banner) return;
  var publish = trackingFunctions.publish,
    sendServerClickEvents = trackingFunctions.sendServerClickEvents;
  var eventName = isVideo ? 'promotion:video:click' : 'promotion:click';
  var eventPayload = buildGtmBannerEventData(banner, isBannerCarousel, screenName, structure, eventDetails);
  sendServerClickEvents(buildServerEventData(banner, eventDetails.index));
  publish(eventName, eventPayload);
};
var trackImpression = function trackImpression(_ref3) {
  var banner = _ref3.banner,
    eventDetails = _ref3.eventDetails,
    isBannerCarousel = _ref3.isBannerCarousel,
    isVideo = _ref3.isVideo,
    publish = _ref3.publish,
    screenName = _ref3.screenName,
    sendServerImpressionEvents = _ref3.sendServerImpressionEvents,
    structure = _ref3.structure;
  var eventName = isVideo ? 'promotion:video:view' : 'promotion:view';
  var eventPayload = buildGtmBannerEventData(banner, isBannerCarousel, screenName, structure, eventDetails);
  sendServerImpressionEvents(buildServerEventData(banner, eventDetails.index));
  publish(eventName, eventPayload);
};
export { buildVideoProgressionEventData, getCustomerId, trackClick, trackImpression };